import {Record as record} from 'immutable';

export default record(
    {
        byOwnerProperties: {},
        byOwnerPropertiesFetchFailed: false,
        byOwnerPropertiesFetchSuccess: false,
        propertyContentItems: [],
        recommendedProperties: {},
        recommendedPropertiesFetchSuccess: false,
        recommendedPropertiesFetchFailed: false,
        recommendedPropertiesIsFetching: false,
        registrationNumber: '',
        unitSpaces: {},
        unitContentItems: [],
        unitMetadata: [],
        urgencyMessage: null,
        discoveryFeed: {},
        rankedBadges: [],
        pricingBadges: [],
        superlativeBadges: [],
        geoRelativeDistances: null,
        description: null,
        localizedPropertyDescriptionMap: {}
    },
    'listingExtended'
);
